export default {"src":"https://search.testwiggot.com/_next/static/media/asterisk.681e2405.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};